module.exports = __webpack_public_path__ + "media/blog_shared_transformation_onboarding.4a0b5b73.mp4";